<app-notification-popup></app-notification-popup>
<ng-container>
  <router-outlet></router-outlet>
</ng-container>
<app-application-loader></app-application-loader>
